import {
  LOGIN3,
  LOGIN3_SUCCESS,
  LOGIN3_FAILED,
  SIGN3,
  SET_USER_PERSISTENT_PROFILE3,
  UPDATE_USER_ATTRIBUTES3,
  LOGIN3_SESSION,
  LOGIN3_METADATA,
  SIGN3_SESSION,
} from "../constants";
import produce from "immer";
import merge from "lodash/merge";

const initialState = {
  authenticated: false,
  user: null,
  userPersistentProfile: {},
  authMessage: null,
  loginMetadata: null,
  loginSessionData: null,
};

const user3Reducer = produce((draft, action) => {
  switch (action.type) {
    case LOGIN3: {
      draft.authMessage = null;
      break;
    }
    case SIGN3: {
      draft.authMessage = null;
      break;
    }
    case LOGIN3_METADATA: {
      draft.loginMetadata = action.metadata;
      break;
    }
    case LOGIN3_SESSION: {
      draft.loginSessionData = action.sessionData;
      break;
    }
    case LOGIN3_FAILED: {
      draft.authenticated = false;
      draft.authMessage = action.errorMsg;
      break;
    }
    case LOGIN3_SUCCESS: {
      draft.authenticated = true;
      draft.authMessage = null;
      draft.user = {
        userName: action.userName,
        ...action.user,
      };
      draft.userPersistentProfile = action.userPersistentProfile;
      break;
    }
    case SIGN3_SESSION: {
      draft.signSessionData = action.sessionData;
      break;
    }
    case UPDATE_USER_ATTRIBUTES3: {
      draft.user = {
        ...draft.user,
        ...action.attributes,
      };
      break;
    }
    case SET_USER_PERSISTENT_PROFILE3: {
      if (action.reset) {
        draft.userPersistentProfile = action.payload;
      } else {
        const d = merge(draft.userPersistentProfile, action.payload);
        draft.userPersistentProfile = d;
      }
      break;
    }
    default:
      break;
  }
}, initialState);

export default user3Reducer;

/* Getters */

export const getUser = (state) => {
  return state.user;
};

export const getUserPersistentProfile = (state) => {
  return state.userPersistentProfile;
};

export const getIsAuthenticated = (state) => {
  return state.authenticated;
};

export const getAuthStatus = (state) => {
  return {
    isAuthenticated: state.authenticated,
    message: state.authMessage,
  };
};

export const getLoginSession = (state) => {
  return state.loginSessionData;
};

export const getLoginMetadata = (state) => {
  return state.loginMetadata;
};

export const getSignSession = (state) => {
  return state.signSessionData;
};
